import React from 'react';
import { PublicClientApplication, EventType, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from '../authConfig';
import { MsalProvider } from '@azure/msal-react';

// Create the msalInstance here
export const msalInstance = new PublicClientApplication(msalConfig);

interface AuthProviderProps {
    children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    const [initialized, setInitialized] = React.useState(false);

    React.useEffect(() => {
        msalInstance.initialize().then(() => {
            if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
                msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
            }

            msalInstance.addEventCallback((event) => {
                const authenticationResult = event.payload as AuthenticationResult;
                const account = authenticationResult?.account;
                if (event.eventType === EventType.LOGIN_SUCCESS && account) {
                    msalInstance.setActiveAccount(account);
                }
            });

            setInitialized(true);
        })
    }, []);

    if (!initialized) {
        return null; // or a loading spinner
    }
    return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export function useAuthProvider() {
    // You can expand this hook as needed
    return { AuthProvider };
}